import { DescriptionResponseBuilder } from './DescriptionResponseBuilder';
import { ItineraryDayResponseBuilder } from './ItineraryDayResponseBuilder';
import { ItineraryRouteResponseBuilder } from './ItineraryRouteResponseBuilder';
import { DurationInfoResponseBuilder } from './DurationInfoResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class ItineraryReferenceResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('ItineraryReference');
    }
    public withId = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['id'] = this.initField(null, args);
        return this;
    }

    public withItineraryType = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['itineraryType'] = this.initField(null, args);
        return this;
    }

    public withDescription = (builder: DescriptionResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['description'] = this.initField(builder, args);
        return this;
    }

    public withItineraryDays = (builder: ItineraryDayResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['itineraryDays'] = this.initField(builder, args);
        return this;
    }

    public withItineraryRoutes = (builder: ItineraryRouteResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['itineraryRoutes'] = this.initField(builder, args);
        return this;
    }

    public withDuration = (builder: DurationInfoResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['duration'] = this.initField(builder, args);
        return this;
    }
}
